import React, { useEffect } from 'react';

/**
 * Componente para manejar el callback de logout de Cognito
 * Este componente se renderiza cuando el usuario regresa de Cognito después del logout
 * Nota: El callback de logout ya se procesa automáticamente por react-oidc-context
 * a través de matchSignoutCallback y onSignoutCallback en index.tsx
 */
const LogoutCallback: React.FC = () => {
  useEffect(() => {
    window.location.replace("https://kubiy.com");
  }, []);

  return null;
};

export default LogoutCallback;

